import React, { Component } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import "firebase/database"
import "firebase/storage"

import avatar1 from "../../assets/images/users/avatar-1.jpg"
import profileImg from "../../assets/images/profile-img.png"
import { connect } from "react-redux"
import PropTypes from 'prop-types'
import { withTranslation } from "react-i18next"

class WelcomeComp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user:[],
      rc:0,
      vc:0
    }
  }
  componentDidMount() {
    const { user } = this.state
    if (user && !user.length) {
      //onGetStaff()
      this.getUser()
    }
    this.getVehicle()
    this.getReservation()
  }
  getVehicle = async () => {
    this.setState({ loading: true });
    const branch = JSON.parse(localStorage.getItem("branch"));
  
    if (!branch) {
     //toast.error("Error: Branch not found");
      this.setState({ loading: false });
      return;
    }
    
    // Unsubscribe previous listeners to prevent memory leaks
    if (this.unsubscribeVehicles) {
      this.unsubscribeVehicles();
    }

    this.unsubscribeVehicles = firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        const userId = user.uid;
        const usersCollection = firebase.firestore().collection("users")
        const userDocRef = usersCollection.doc(userId);

        try {
          const userDoc = await userDocRef.get();
          if (userDoc.exists) {
            const userId = userDoc.data().id;
            const userVehiclesCollectionRef = usersCollection.doc(userId).collection("vehicles").where("branchId","==",branch)

            this.unsubscribeVehicles = userVehiclesCollectionRef.onSnapshot(snapshot => {
              this.setState({
                vc:snapshot.docs.length
              })
            });

            //localStorage.setItem("authUser", JSON.stringify(user));
          } else {
            // User document not found
            localStorage.removeItem("authUser");
            this.setState({
              loading: false,
              vc: 0
            });
          }
        } catch (error) {
         //console..error("Error fetching user document:", error);
          // Handle error
        }
      } else {
        localStorage.removeItem("authUser");
        // Clear the reservations if user is not authenticated
        this.setState({
          loading: false,
          vc: 0
        });
      }
    });
  }
  getReservation = async () => {
    this.setState({ loading: true });
    const branch = JSON.parse(localStorage.getItem("branch"));
  
    if (!branch) {
     //toast.error("Error: Branch not found");
      this.setState({ loading: false });
      return;
    }
    
    // Unsubscribe previous listeners to prevent memory leaks
    if (this.unsubscribeReservations) {
      this.unsubscribeReservations();
    }

    this.unsubscribeReservations = firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        const userId = user.uid;
        const usersCollection = firebase.firestore().collection("users")
        const userDocRef = usersCollection.doc(userId);

        try {
          const userDoc = await userDocRef.get();
          if (userDoc.exists) {
            const userId = userDoc.data().id;
            const userReservationsCollectionRef = usersCollection.doc(userId).collection("reservations").where("branchId","==",branch)

            this.unsubscribeReservations = userReservationsCollectionRef.onSnapshot(snapshot => {
              
              this.setState({
                rc:snapshot.docs.length
              });
            });

            //localStorage.setItem("authUser", JSON.stringify(user));
          } else {
            // User document not found
            localStorage.removeItem("authUser");
            this.setState({
              rc:0
            });
          }
        } catch (error) {
         //console..error("Error fetching user document:", error);
          // Handle error
        }
      } else {
        localStorage.removeItem("authUser");
        // Clear the reservations if user is not authenticated
        this.setState({
          rc:0
        });
      }
    });
  }
  getUser = async () => {
    this.setState({ loading: true });

    // Unsubscribe previous listeners to prevent memory leaks
    if (this.unsubscribeUsers) {
      this.unsubscribeUsers();
    }

    this.unsubscribeUsers = firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        const userId = user.uid;
        const usersCollection = firebase.firestore().collection("users")
        const userDocRef = usersCollection.doc(userId);

        try {
          const userDoc = await userDocRef.get();
          if (userDoc.exists) {
            const userId = userDoc.data().id;
            const userUsersCollectionRef = usersCollection.doc(userId)

            this.unsubscribeUsers = userUsersCollectionRef.onSnapshot(snapshot => {
              let kra = snapshot.data()
              this.setState({
              loading: false,
              user: kra,
            })
            });

            //localStorage.setItem("authUser", JSON.stringify(user));
          } else {
            // User document not found
            localStorage.removeItem("authUser");
            
          }
        } catch (error) {
         //console..error("Error fetching user document:", error);
          // Handle error
        }
      } else {
        localStorage.removeItem("authUser");
        // Clear the reservations if user is not authenticated
        
      }
    });

  }
  render() {
    const {user,rc,vc}=this.state
   var av=""
   if(user.image_url==""){
    av=avatar1
   }else{
    av=user.image_url
   }
    return (
      <React.Fragment>
        <Card className="overflow-hidden">
          <div className="bg-primary bg-soft">
            <Row>
              <Col xs="7">
                <div className="text-primary p-3">
                  <h5 className="text-primary">{this.props.t("Welcome Back !")}</h5>
                  <p>{this.props.t("Medios Dashboard")}</p>
                </div>
              </Col>
              <Col xs="5" className="align-self-end">
                <img src={profileImg} alt="" className="img-fluid" />
              </Col>
            </Row>
          </div>
          <CardBody className="pt-0">
            <Row>
              <Col sm="4">
                <div className="avatar-md profile-user-wid mb-4">
                  <img
                    src={av}
                    alt=""
                    className="avatar-md rounded-circle img-thumbnail"
                  />
                </div>
                <h5 className="font-size-15 text-truncate">{user.company_name}</h5>
                {user.username?<p className="text-muted mb-0 text-truncate">@{user.username}</p>:null}
              </Col>

              <Col sm="8">
                <div className="pt-4">
                  <Row>
                    <Col xs="6">
                      <h5 className="font-size-15">{rc}</h5>
                      <p className="text-muted mb-0">{this.props.t("Reservations")}</p>
                    </Col>
                    <Col xs="6">
                      <h5 className="font-size-15">{vc}</h5>
                      <p className="text-muted mb-0">{this.props.t("Vehicles")}</p>
                    </Col>
                  </Row>
                  <div className="mt-4">
                    <Link
                      to="/profile"
                      className="btn btn-primary btn-sm"
                    >
                      {this.props.t("Profile")}
                       {" "}<i className="mdi mdi-arrow-right ms-1"/>
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}


WelcomeComp.propTypes = {
  t: PropTypes.any
}

export default withTranslation()(WelcomeComp);

